import { createContext, useState } from "react";

export const ReportModalContext = createContext();

export function ReportModalProvider({ children }) {
  const [isReportModalVisible, setIsReportModalVisible] = useState(false);
  const [results, setResults] = useState(null); // ⭐ ADDED

  return (
    <ReportModalContext.Provider
      value={{
        isReportModalVisible,
        setIsReportModalVisible,
        results,
        setResults,
      }}
    >
      {children}
    </ReportModalContext.Provider>
  );
}
